import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ReactComponent as CloseBtn } from "../../../assets/icons/Icon.svg";
import { STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE } from "../../../redux/actions-type";
import { updateStudentPerformanceCommonResult } from "../../../redux/actions/studentPerformanceActions";
import { Box, TextField } from "@mui/material";
import SubmitBtn from "./components/SubmitBtn";
// import SubmitBtn from "./components/SubmitBtn";

const StudentPerformanceCommonModal = () => {
  const dispatch = useDispatch();

  const { studentPerformanceCommonModalData: modalData } = useSelector(
    (state) => state.studentPerformanceCommonModal,
  );


  const [portfolioResult, setPortfolioResult] = useState(
    modalData?.portfolioResult ?? "",
  );
  const [juryEvaluation, setJuryEvaluation] = useState(
    modalData?.juryEvaluation ?? "",
  );
  const [error, setError] = useState("");

  const closeModal = () => {
    dispatch({
      type: STUDENT_PERFORMANCE_COMMON_MODAL_ACTION_TYPE.GET_STUDENT_PERFORMANCE_COMMON_MODAL,
      payload: { data: {}, openModal: false },
    });
  };

  // dəyəri düzgün formata çevir
  const parseValue = (value) => {
    if (value === "") return null;
    if (value.toLowerCase() === "x") return "x";
    if (!isNaN(Number(value))) return Number(value);
    return null;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (!modalData?._id) {
      setError("ID tapılmadı");
      return;
    }

    const updateData = {
      portfolioResult: parseValue(String(portfolioResult)),
      juryEvaluation: parseValue(String(juryEvaluation)),
    };

    dispatch(updateStudentPerformanceCommonResult(modalData._id, updateData));
  };

  return (
    <div className="create-update-modal-con teacher-modal">
      <div className="create-update-modal">
        <div className="create-update-modal-head">
          <h2>Ümumi nəticəni yenilə</h2>
          <CloseBtn onClick={closeModal} />
        </div>

        <Box
          component="form"
          sx={{
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
          }}
          onSubmit={handleSubmit}
          className="create-update-modal-form"
        >
          {/* Portfolio nəticəsi */}
          <TextField
            sx={{
              "& input": { fontSize: "12px" },
              marginTop: "24px",
            }}
            InputLabelProps={{
              style: { fontSize: "12px", color: "#3F3F3F" },
            }}
            fullWidth
            label="Portfolio nəticəsi"
            autoComplete="off"
            value={portfolioResult}
            onChange={(e) => setPortfolioResult(e.target.value)}
            placeholder="Boş, rəqəm və ya x"
          />

          {/* Münsif dəyərləndirmə */}
          <TextField
            sx={{
              "& input": { fontSize: "12px" },
              marginTop: "24px",
            }}
            InputLabelProps={{
              style: { fontSize: "12px", color: "#3F3F3F" },
            }}
            fullWidth
            label="Münsif dəyərləndirmə"
            autoComplete="off"
            value={juryEvaluation}
            onChange={(e) => setJuryEvaluation(e.target.value)}
            placeholder="Boş, rəqəm və ya x"
          />

          {error && <p className="error-message">{error}</p>}

          <div className="create-update-modal-footer">
            <SubmitBtn modalData={modalData} funcType="update" />
          </div>
        </Box>
      </div>
    </div>
  );
};

export default StudentPerformanceCommonModal;
